import produce from 'immer';

import type { PageData } from '@swf/core/types/Poker';
import type { HgScheduledTournament } from '@swf/generated/types/api/v0/SwHomeGames';
import type { CommSrvTime } from '@swf/generated/types/api/v1-preview/SwHomeGames';
import { parseCommlibDate } from '@swf/poker';

export const setRegisteredTournaments = (
  state: PageData,
  { response }: { response: HgScheduledTournament[] }
) => {
  const scheduled = response
    .filter((tourn: HgScheduledTournament) => tourn.registered)
    .sort(
      (prev: HgScheduledTournament, next: HgScheduledTournament) =>
        parseCommlibDate(prev.startTime as CommSrvTime).getTime() -
        parseCommlibDate(next.startTime as CommSrvTime).getTime()
    );

  return produce(state, (draft) => {
    draft.games.registeredTourns = scheduled;
  });
};
